import pathOr from "ramda/src/pathOr";

export const pathOrFalse = pathOr(false);
